export default __webpack_public_path__ + "static/media/logo_marianne.ccf40c5e.png";